import React from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { CustomerProvider } from '@material-bank/customer';
import { ProjectsCustomerProvider } from '@material-bank/projects-utils';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { ThemeContainer } from 'ui-widgets';
import Snackbar from './components/Snackbar';
import { useSnackbar } from './hooks/useSnackbar';
import { RecommendationsModalContainer } from './RecommendationsModalContainer/RecommendationsModalContainer';

const RecommendationsModalApp = () => {
  const { snackbarInfo, setSnackbarInfo, toggleSnackbarInfo } = useSnackbar();

  return (
    <ApolloProvider>
      <IntlProvider>
        <ThemeContainer>
          <CustomerProvider>
            <ProjectsCustomerProvider>
              <RecommendationsModalContainer
                toggleSnackbarInfo={toggleSnackbarInfo}
              />
            </ProjectsCustomerProvider>
          </CustomerProvider>
          <Snackbar
            isOpen={snackbarInfo.isOpen}
            otherProps={snackbarInfo.otherProps}
            setSnackbarInfo={setSnackbarInfo}
          />
        </ThemeContainer>
      </IntlProvider>
    </ApolloProvider>
  );
};

export default RecommendationsModalApp;
